import React from 'react';
import PropTypes from 'prop-types';
import {
  Components, Theme, Utils, translate,
} from 'versafleet-core';
import moment from 'moment';

class NotificationItem extends React.Component {
  _onClick = () => {
    this.props.onClick(this.props.data);
  }

  _renderCompletedJob(notification) {
    const replaceMap = {
      guid: (
        <span className="vf-header-notification__item__content__description--blue">
          {notification.data && notification.data.job.guid}
        </span>
      ),
      customerName: (
        <span className="vf-header-notification__item__content__description--blue">
          {notification.data && notification.data.job.customer.name}
        </span>
      ),
    };

    return (
      <div className="vf-header-notification__item__content">
        <Components.CircleIcon
          className="vf-header-notification__item__content__icon"
          iconClassName="versa-business"
        />
        <div className="vf-header-notification__item__content__description">
          {Utils.TranslationHelper.replaceTag(this.props.strings.completedJob, replaceMap)}
        </div>
      </div>
    );
  }

  _renderAcceptedJob(notification) {
    const replaceMap = {
      guid: (
        <span className="vf-header-notification__item__content__description--blue">
          {notification.data && notification.data.job.guid}
        </span>
      ),
    };

    return (
      <div className="vf-header-notification__item__content">
        <Components.CircleIcon
          className="vf-header-notification__item__content__icon"
          iconClassName="versa-business"
        />
        <div className="vf-header-notification__item__content__description">
          {Utils.TranslationHelper.replaceTag(this.props.strings.acceptedJob, replaceMap)}
        </div>
      </div>
    );
  }

  _renderRejectedJob(notification) {
    const replaceMap = {
      guid: (
        <span className="vf-header-notification__item__content__description--blue">
          {notification.data && notification.data.job.guid}
        </span>
      ),
      reason: notification.data ? (
        <span className="vf-header-notification__item__description--bold">
          {notification.data && notification.data.myjobs_rejection_note}
        </span>
      ) : false,
    };

    return (
      <div className="vf-header-notification__item__content">
        <Components.CircleIcon
          className="vf-header-notification__item__content__icon"
          iconClassName="versa-business"
        />
        <div className="vf-header-notification__item__content__description">
          {
            !Utils.Helper.isNonEmptyString(notification.data.myjobs_rejection_note)
              ? Utils.TranslationHelper.replaceTag(
                this.props.strings.rejectedJobWithoutReason, replaceMap,
              ) : Utils.TranslationHelper.replaceTag(this.props.strings.rejectedJob, replaceMap)
          }
        </div>
      </div>
    );
  }

  _renderJob(notification, keyword) {
    const replaceMap = {
      customerName: (
        <span className="vf-header-notification__item__content__description--blue">
          {`${notification.data.job.customer.name} `}
        </span>
      ),
      keyword: (
        <span className="vf-header-notification__item__content__description--bold">
          {this.props.strings.constants[keyword]}
        </span>
      ),
      guid: (
        <span className="vf-header-notification__item__content__description--blue">
          {` ${notification.data.job.guid} `}
        </span>
      ),
    };

    return (
      <div className="vf-header-notification__item__content">
        <Components.CircleIcon
          className="vf-header-notification__item__content__icon"
          iconClassName="versa-business"
        />
        <div className="vf-header-notification__item__content__description">
          {Utils.TranslationHelper.replaceTag(this.props.strings.job, replaceMap)}
        </div>
      </div>
    );
  }

  _renderTask(notification, keyword) {
    const iconMap = {
      acknowledged: ['versa-arrow-down', Theme.Color.$teal01, Theme.Color.$desc],
      started: ['versa-started2', Theme.Color.$teal01, Theme.Color.$desc],
      declined: ['versa-warning', Theme.Color.$bluelighter1, Theme.Color.$red],
      failed: ['versa-warning', Theme.Color.$bluelighter1, Theme.Color.$red],
      cancelled: ['versa-danger', Theme.Color.$bluelighter1, Theme.Color.$red],
      succeeded: ['versa-completed', Theme.Color.$green, Theme.Color.$bluelighter1],
      collected: ['versa-completed', Theme.Color.$green, Theme.Color.$bluelighter1],
      arrived: ['versa-arrived', Theme.Color.$green, Theme.Color.$bluelighter1],
    };

    const shouldShowPartial = notification.data.task.is_partial_success && keyword === 'succeeded';

    const replaceMap = {
      partial: shouldShowPartial ? (
        <span className="vf-header-notification__item__content__description--bold">
          {this.props.strings.partial}
        </span>
      ) : false,
      driverName: (
        <span className="vf-header-notification__item__content__description--blue">
          {Utils.Helper.isNullOrUndefined(notification.data.task.task_assignment.driver) ? ''
            : notification.data.task.task_assignment.driver.name}
        </span>
      ),
      keyword: (
        <span className="vf-header-notification__item__content__description--bold">
          {this.props.strings.driverConstants[keyword]}
        </span>
      ),
      guid: (
        <span className="vf-header-notification__item__content__description--blue">
          {notification.data.task.guid}
        </span>
      ),
      customerName: (
        <span className="vf-header-notification__item__content__description--blue">
          {notification.data.task?.job?.customer?.name || notification.data.task?.customer?.name}
        </span>
      ),
    };

    return (
      <div className="vf-header-notification__item__content">
        <Components.CircleIcon
          className={`${'vf-header-notification__item__content__icon '
            + 'vf-header-notification__item__content--'}${keyword}`}
          iconClassName={shouldShowPartial ? 'versa-completedpartially' : iconMap[keyword][0]}
          innerIconColor={iconMap[keyword][2]}
          outerIconColor={iconMap[keyword][1]}
        />
        {Utils.Helper.isNullOrUndefined(notification.data.task.task_assignment.driver) ? (
          <div className="vf-header-notification__item__content__description">
            {Utils.TranslationHelper.replaceTag(this.props.strings.taskWithoutDriver,
              replaceMap)}
          </div>
        ) : (
          <div className="vf-header-notification__item__content__description">
            {Utils.TranslationHelper.replaceTag(this.props.strings.taskWithDriver,
              replaceMap)}
          </div>
        )}
      </div>
    );
  }

  _renderNotificator(notification) {
    const { notificator, task } = notification.data;
    const { strings } = this.props;

    const absoluteMinutes = Math.abs(notificator.minutes);
    const shouldShowPartial = notificator.action_name === 'succeeded' && task.is_partial_success;

    const replaceMap = {
      partial: shouldShowPartial ? (
        <span className="vf-header-notification__item__content__description--bold">
          {this.props.strings.partial}
        </span>
      ) : false,
      taskGUID: (
        <span className="vf-header-notification__item__content__description--blue">
          {task.guid}
        </span>
      ),
      hasBeen: (
        <span className="vf-header-notification__item__content__description--bold">
          {notificator.is_been ? strings.isBeen : strings.isNotBeen}
        </span>
      ),
      actionName: (
        <span className="vf-header-notification__item__content__description--bold">
          {strings.notificatorConstants[notificator.action_name]}
        </span>
      ),
      hourCount: (
        <span className="vf-header-notification__item__content__description--bold">
          {Math.floor(absoluteMinutes / 60)}
        </span>
      ),
      hours: (
        <span className="vf-header-notification__item__content__description--bold">
          {strings.hours}
        </span>
      ),
      minuteCount: (
        <span className="vf-header-notification__item__content__description--bold">
          {absoluteMinutes % 60}
        </span>
      ),
      minutes: (
        <span className="vf-header-notification__item__content__description--bold">
          {strings.minutes}
        </span>
      ),
      timePreposition: (
        <span className="vf-header-notification__item__content__description--bold">
          {parseInt(notificator.minutes, 10) < 0 ? strings.after : strings.before}
        </span>
      ),
      time: moment(task[notificator.trigger_name]).format('HH:mm:ss, DD MMM YYYY'),
    };

    return (
      <div className="vf-header-notification__item__content">
        <Components.CircleIcon
          className="vf-header-notification__item__icon"
          iconClassName="versa-notifications"
        />
        <div className="vf-header-notification__item__description">
          {notificator.minutes >= 60
            ? Utils.TranslationHelper.replaceTag(strings.notificatorWithHours, replaceMap)
            : Utils.TranslationHelper.replaceTag(strings.notificatorWithoutHours, replaceMap)}
        </div>
      </div>
    );
  }

  _renderNotification() {
    switch (this.props.data.category) {
      case 'job_completed':
        return this._renderCompletedJob(this.props.data);
      case 'job_rejected':
        return this._renderRejectedJob(this.props.data);
      case 'job_accepted':
        return this._renderAcceptedJob(this.props.data);
      case 'job_submitted':
        return this._renderJob(this.props.data, 'submitted');
      case 'job_revoked':
        return this._renderJob(this.props.data, 'retracted');
      case 'job_cancelled':
        return this._renderJob(this.props.data, 'cancelled');
      case 'task_acknowledged':
        return this._renderTask(this.props.data, 'acknowledged');
      case 'task_declined':
        return this._renderTask(this.props.data, 'declined');
      case 'task_started':
        return this._renderTask(this.props.data, 'started');
      case 'task_failed':
        return this._renderTask(this.props.data, 'failed');
      case 'task_rejected':
        return this._renderTask(this.props.data, 'rejected');
      case 'task_successful':
        return this._renderTask(this.props.data, 'succeeded');
      case 'task_collected':
        return this._renderTask(this.props.data, 'collected');
      case 'task_cancelled':
        return this._renderTask(this.props.data, 'cancelled');
      case 'task_arrived':
        return this._renderTask(this.props.data, 'arrived');
      case 'task_notificator':
        return this._renderNotificator(this.props.data);
      default:
        return null;
    }
  }

  render() {
    return (
      <div
        className="vf-header-notification__item"
        id="vf-header-notification__item"
        onClick={this._onClick}
      >
        {this._renderNotification()}
        <div className="vf-header-notification__item__content__created-time">
          {moment(this.props.data.created_at).fromNow(true)}
        </div>
      </div>
    );
  }
}

NotificationItem.displayName = 'Notification Item';

NotificationItem.propTypes = {
  data: PropTypes.shape().isRequired,
  onClick: PropTypes.func.isRequired,
  strings: PropTypes.shape().isRequired,
};

export default translate('Notification')(NotificationItem);
